import { time } from '../frameloop/sync-time.mjs';
import { frame, cancelFrame } from '../frameloop/frame.mjs';

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
  var start = time.now();
  var checkElapsed = function checkElapsed(_ref) {
    var timestamp = _ref.timestamp;
    var elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return function () {
    return cancelFrame(checkElapsed);
  };
}
export { delay };